import Back from "../Icon/Back";
import { getDate } from "./utils";

export function Heading({ plan, backPath, click, children }) {
  return (
    <div className="lp-table-heading">
      {click || backPath ? <Back backPath={backPath} click={click}/>:null}
      {plan?.sectionId?.grade? (
        <div className="content">
          <p>
            <b>Date</b>
            {" : "}
            <span>{plan?.startDate && getDate(plan?.startDate)}</span>
          </p>
          <p>
            <b>{`${plan?.sectionId?.grade || ""}-${
              plan?.sectionId?.section
            } > ${plan?.subjectId?.name || ""} > ${
              plan?.chapterId?.name || plan?.customChapter || ""
            } > ${plan?.topicId?.name || plan?.customTopic || ""} > ${plan?.moduleId?.name || plan?.customModule || ""}`}</b>
          </p>
        </div>
      ) : null}
      {children}
    </div>
  );
}

export function GroupHeading({ startDate, backPath, click, children }) {
  return (
    <div className="lp-table-heading">
      {click || backPath ? <Back backPath={backPath} click={click}/>:null}
        <div className="content">
          <p>
            <b>Date</b>
            {" : "}
            <span>{startDate && getDate(startDate)}</span>
          </p>
          
        </div>
      {children}
    </div>
  );
}

export function Button({ children, style, onClick, disabled = false }) {
  return (
    <button
      type="button"
      style={{
        fontFamily: "Poppins",
        height: "fit-content",
        margin: "auto 0",
        display:"flex",
        alignItems:"center",
        gap:"4px",
        letterSpacing:"1px",
        ...style
      }}
      className={"button selected_button opacity-60 disabled:opacity-40"}
      onClick={onClick}
      id="button_70"
      disabled={disabled}
    >
      {children}
    </button>
  );
}
